Vue.filter('forceHttps', function(value) {
    if (!value) return '';
    return value.replace('http://', 'https://');
});

Vue.filter('stripTags', function(value, lgth) {
    if (!value) return '';
    value = value.toString().replace(/&lt;.+?&gt;/g, '');
    value = lodash.unescape(value);
    if (lgth) {
        return value && value.length > lgth ? value.slice(0,lgth).split(' ').slice(0, -1).join(' ') + '...' : value
    }
    return value
});

Vue.filter('splitMore', function(value) {
    if (!value) return ''
    if (value.search("<!--more-->") == -1) return value
    return value.split('<!--more-->')[0]
});

Vue.filter('formatDate', function(date, dateFormat, formatDate, lang) {
    //ex dateFormat 'yyyy-mm-dd'
    //ex formatDate number 'DD'
    //ex formatDate day 'dddd'
    //ex formatDate month 'MMMM'
    if (date) {
        //moment.locale(lang);
        return moment(date, dateFormat).format(formatDate);
    }
});

Vue.filter('formatTimestamp', function(value, format, lang) {
    if (value) {
        moment.locale(lang);
        return moment.unix(String(value)).format(format)
    }
});

Vue.filter('displayLibelle', function(value) {
    if (!value) return '';
    let libelle = `libelle${apidae.lang_url.charAt(0).toUpperCase()}${apidae.lang_url.slice(1)}`
    return value[libelle];
});

Vue.filter('nl2br', function(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
});

/**
 * Vue filter to round the decimal to the given place.
 * http://jsfiddle.net/bryan_k/3ova17y9/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
 Vue.filter('round', function(value, decimals) {
    if(!value) {
      value = 0;
    }
  
    if(!decimals) {
      decimals = 0;
    }
  
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
});

Vue.filter('divideTextBySpan', (text) => {
    const textLength = text.length;
    const textArray = text.split(" ");
    let content = [];
  
    textArray.every( word => {
      const cIndex = content.length - 1;
      const lastInLine = content[cIndex];
      const combined = `${lastInLine} ${word}`;
  
      if (lastInLine !== undefined && combined.length < 14) {
        content[cIndex] = combined;
  
        return true;
      }
  
      content.push(word);
  
      return true;
    })
  
    return content.map(line => `<span class="block">${line}</span>`).join("\n")
  });